import { DraftCreateActionSelectModal } from '../../Draft'
import { EMAIL_CREATION_FORM_FIELD_NAME_MASS_MAILING } from '../EmailCreationForm'

function EmailDraftCreateActionSelectModal({ draft, ...restProps }) {
  // The mass-mailing wording only fits drafts saved with the checkbox on;
  // regular drafts reuse the neutral request-draft text.
  const actionTitleKey = draft?.[EMAIL_CREATION_FORM_FIELD_NAME_MASS_MAILING]
    ? 'Email.CreateModalActionTitleKey'
    : 'Request.CreateModalActionTitleKey'

  return (
    <DraftCreateActionSelectModal
      {...restProps}
      createNewLabelKey='Email.CreateNewKey'
      draft={draft}
      formFieldsProps={{ titleKey: actionTitleKey }}
      openDraftLabelKey='Email.OpenDraftKey'
      submitTextKey='Modal.CreateBtnKey'
      titleKey='Email.CreateModalTitleKey'
    />
  )
}

export default EmailDraftCreateActionSelectModal
